import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "howToUseContent",
  style: {"color":"#111"}
}
const _hoisted_2 = {
  key: 0,
  class: "mc centered"
}
const _hoisted_3 = {
  key: 1,
  class: "mc centered pad15 w90"
}
const _hoisted_4 = {
  key: 2,
  class: "mc centered registeredView ofh posRe",
  style: {"height":"500px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", {
  class: "fs32 ls1 mc fw900",
  style: {"margin-top":"80px"}
}, "登録完了", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mc w80 mt40 fs14" }, [
  /*#__PURE__*/_createTextVNode(" ユーザーの登録が完了しました！ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("こちらで登録内容を確認しご連絡いたしますので、しばらくお待ちください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※ 審査の上、ご連絡がいかない場合がございますので、予めご了承ください。 ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  class: "pointer centered circle_button skyblueBg fs16",
  style: {"width":"260px","border-radius":"8px","height":"44px","padding":"13px 8px","margin-top":"40px"},
  rel: "nofollow",
  "data-method": "delete",
  href: "/users/sign_out"
}, "ログアウトしてトップページへ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  style: {},
  class: "mt30"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 3,
  class: "mc centered"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "fs16 ls1 mc fw600 headerTitle" }, "調整カレンダーとは？", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs14 fw600" }, "waaq Linkの使い方", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"1px"} }, "閉じる", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YokosoAgreement = _resolveComponent("YokosoAgreement")!
  const _component_RegistrationForm = _resolveComponent("RegistrationForm")!
  const _component_UsageContent = _resolveComponent("UsageContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.rm.tutorial_phase < 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_YokosoAgreement, {
              isDev: _ctx.isDev,
              action: _ctx.action,
              onAgreed: _ctx.agreed
            }, null, 8, ["isDev", "action", "onAgreed"])
          ]))
        : (_ctx.rm.tutorial_phase < 19)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_RegistrationForm, {
                isDev: _ctx.isDev,
                onComplete: _ctx.completeRegistration
              }, null, 8, ["isDev", "onComplete"])
            ]))
          : (!_ctx.Const.started(this.rm))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "w100 pointer",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickBanner && _ctx.clickBanner(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/notifications/present_cp_wide_kohyo.png`),
                      style: {"width":"100%"}
                    }, null, 8, _hoisted_12)
                  ])
                ]),
                _hoisted_13
              ]))
            : (_ctx.howToUseType == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("p", {
                    class: "centered mc fw600",
                    style: _normalizeStyle(`${_ctx.isSP ? 'margin:5px 5px;' : 'margin:20px 30px 10px 30px;'}`)
                  }, " 調整カレンダーとは、調整相手との互いの空き時間をさがすのに利用します。 ", 4),
                  _createElementVNode("div", {
                    style: _normalizeStyle(`text-align:start; ${_ctx.isSP ? 'margin:5px 5px;' : 'margin:0px 150px;'}`),
                    class: "fl fs13 fw400 pad20"
                  }, [
                    _hoisted_17,
                    _createTextVNode("・作成後は、日程調整の度に入力する必要はありません。 "),
                    _hoisted_18,
                    _createTextVNode("・カレンダー連携することで、自動で同期を行うため予定が重複することはありません。 "),
                    _hoisted_19,
                    _createTextVNode("・調整相手には勝手に共有されることはないため、安心してご利用いただけます。 ")
                  ], 4),
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _hoisted_25,
                  _createVNode(_component_UsageContent),
                  _hoisted_26,
                  _createElementVNode("label", {
                    class: "fs12 pointer circle_button",
                    style: {"padding":"5px 8px 3px 8px","border":"1.5px solid #666"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeWhatStrictCal && _ctx.closeWhatStrictCal(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/close_circle.png`),
                      width: "22",
                      style: {"margin-top":"-4px"}
                    }, null, 8, _hoisted_27),
                    _hoisted_28
                  ]),
                  _hoisted_29,
                  (_ctx.isSP)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_35))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
    ]),
    _hoisted_36,
    _hoisted_37
  ]))
}